// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Check from "@west/XDL/Icons/Check";
import { NamedExoticComponent } from "react";

interface AddToCartStatusInfoInterface {
    status: string;
    label: string;
    icon: NamedExoticComponent<{}> | string;
}
interface AddToCartStatusInterface {
    default: AddToCartStatusInfoInterface;
    loading: AddToCartStatusInfoInterface;
    success: AddToCartStatusInfoInterface;
}

export const constants = {
    footer: {
        offsetTop: 32,
    },
};

export const XNGAGE_CUSTOM_WIDGET = "Xngage" as any;
export const EMPTY_VALUE = "- -";
export const DivWrapper = `div[class^="Wrapper"]`;

export const placeHolders = {
    email: "eg. example@gmail.com",
    phone: "( ___ ) ___ - ____",
};

export const sharedDateTimeOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const ErrorApiDefaultMessage = "Please try again and contact support if you continue to have issues.";

export const UserRolesSystemList = "WestRoles";

export const addToCartStatus: AddToCartStatusInterface = {
    default: {
        status: "default",
        label: "Add to Cart",
        icon: "",
    },
    loading: {
        status: "loading",
        label: "Adding",
        icon: "",
    },
    success: {
        status: "success",
        label: "Success",
        icon: Check,
    },
};

export const XNGAGE_CUSTOM_WIDGETS = "Xngage Custom" as any;

export enum PLP_GRID_VIEW_DOCUMENT_TYPE {
    Image = "firstgridimage",
    Video = "firstgridvideo",
}
